<template>
	<div>
		<div class="row">
			<div class="col s12 m8 l10 xl10">
				<div class="row">
					<div class="input-field col s12">
						<i class="material-icons prefix ">search</i>
						<input id="search" type="text" class="validate" v-model="filterTerm">
						<label for="search">Pesquisar</label>
					</div>
				</div>
			</div>
		</div>
		
		<div class="row">
			<div class="col s12 m12 l12 xl12">
				<table>
					<col width="5%">
					<col width="50%">
					<col width="30%">
					<col width="10%">
					<col width="5%">
					<thead>
						<tr>
							<th>#
								<a class="left" href="#" @click="toggleOrder($event, 'id')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyId }" >sort</i>
								</a>
							</th>
							<th>
								Ação
								<a class="left" href="#" @click="toggleOrder($event, 'titulo')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyProjeto }" >sort</i>
								</a>
							</th>
							<th>
								Membro do Comitê
								<a class="left" href="#" @click="toggleOrder($event, 'comite.name')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyComite }" >sort</i>
								</a>
							</th>
							<th>
								Dados do Avaliador
							</th>
							<th>
								Avaliado?
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(projeto, index) in filteredProjetos">
							<td>{{index + 1}}</td>
							<td>
								<a :href="'/projetos/'+projeto.id+'/edit/editable/false'">
									{{projeto.titulo}}
								</a>
							</td>
							<td>
								<select :id="'/pertinencia/' + projeto.id + '/'" v-model="projeto.comite_id" class="browser-default select_sec" onchange="salvar(this.id, this.value)">
									<option value=null disabled selected>Comitê</option>
									<option v-for="comite in listaComites" v-bind:value="comite.id">{{comite.name}} ({{numProjetos(comite.id)}})</option>
								</select>
							</td>
							<td>
								<a v-if='projeto.comite_id && (!projeto.impedido || projeto.pertinente !== null)' :href="'/usuario/' + projeto.comite_id" class="waves-effect waves-light btn left cyan darken-1 tooltipped" data-tooltip='Informações do avaliador'><i class="material-icons">info</i></a> 
								<label v-if='projeto.comite_id && projeto.impedido && projeto.pertinente === null' class="waves-light btn left red tooltipped" data-tooltip='Avaliador impedido'><i class="material-icons">do_not_disturb_on</i></label>
								<label v-if='!projeto.comite_id' class="waves-light btn left red tooltipped" data-tooltip='Ação sem avaliador'><i class="material-icons">error</i></label>
							</td>
							<td>
								<label v-if='projeto.pertinente === null' class="waves-light btn red left"><i class="material-icons">clear</i></label>
								<label v-else class="waves-light btn left cyan darken-1"><i class="material-icons">check</i></label>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
		name: "VuePertinenciaList",
		props: [
			'projetos',
			'comites'
		],
		data () {
			return {
				listaProjetos: JSON.parse(this.projetos),
				listaComites: JSON.parse(this.comites),
				sortDirection: 'asc',
				filterTerm: '',
				sortProperty: 'id',
				sortPropertyId: true,
				sortPropertyProjeto: false,
				sortPropertyComite: false,
			}
		},
		computed: {
			filteredProjetos: function () {
				var self = this
				return _.orderBy(self.listaProjetos.filter(function (projeto) {
					var searchRegex = new RegExp(self.filterTerm, 'i')
					return (
						searchRegex.test(projeto.titulo) ||
						searchRegex.test(projeto.comite.name) 
					)
				}), this.sortProperty, this.sortDirection)
			},
		},
		methods: {
			toggleOrder(ev, field) {
				ev.preventDefault()
				if (this.sortProperty == field) {
					if (this.sortDirection == 'asc')
						this.sortDirection = 'desc'
					else
						this.sortDirection = 'asc'
				} else {
					this.iconsColor(this.sortProperty, false)
					this.iconsColor(field, true)
					this.sortProperty = field
					this.sortDirection = 'asc'
				}
			},
			iconsColor(field, value) {
				switch (field) {
					case 'id':
					  this.sortPropertyId = value
					  break;
					case 'titulo':
					  this.sortPropertyProjeto = value
					  break;
					case 'comite.name':
					  this.sortPropertyComite = value
					  break;
					default:
				}
			},
			numProjetos(id) {
				var lista = this.listaProjetos,
					i = lista.length,
				    num = 0;
					
				while (--i >= 0)
					if (lista[i].comite_id == id)
						num++;
						
				return num;
			}
		}
	}
</script>